import { Component, Input, Output, EventEmitter, ViewChild, ViewContainerRef, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuseDrawerModule, FuseDrawerComponent } from '@fuse/components/drawer';
import { FuseDrawerMode, FuseDrawerPosition } from '@fuse/components/drawer/drawer.types';
import { DrawerHeaderComponent } from './drawer-header.component';

@Component({
  selector: 'cipx-drawer-template',
  template: `
    <fuse-drawer
      [fixed]="fixed"
      [sizeType]="sizeType"
      [showUpBand]="showUpBand"
      [mode]="mode"
      [name]="name"
      [opened]="opened"
      [position]="position"
      [transparentOverlay]="transparentOverlay"
      [disableOverlay]="disableOverlay"
      [disableOverlayClick]="disableOverlayClose"
      [showCloseButton]="showCloseButton"
      (openedChanged)="openedChanged.emit($event)">
      <div class="drawer-container flex flex-col h-full">
        <!-- Header -->
        <div class="drawer-header p-4 border-b" *ngIf="showHeader">
          <cipx-drawer-header
            [title]="title"
            [showCloseButton]="true"
            [showBackButton]="showBackButton"
            (closeEvent)="closeClick.emit()"
            (backEvent)="backClick.emit()"></cipx-drawer-header>
        </div>

        <!-- Content Stage -->
        <div class="drawer-content-stage flex-1">
          <!-- Dynamic content will be inserted here -->
          <ng-container #drawerContent></ng-container>
          <!-- Static content from ng-content -->
          <ng-content></ng-content>
        </div>
      </div>
    </fuse-drawer>
  `,
  styleUrls: ['./drawer.component.scss'],
  imports: [
    CommonModule,
    FuseDrawerModule,
    DrawerHeaderComponent
  ],
  standalone: true,
})
export class CIPXDrawerTemplateComponent implements AfterViewInit {
  @ViewChild(FuseDrawerComponent) fuseDrawer!: FuseDrawerComponent;
  @ViewChild('drawerContent', { read: ViewContainerRef }) drawerContent!: ViewContainerRef;

  // Inputs
  @Input() fixed = true;
  @Input() sizeType: 'small' | 'half' | 'large' = 'half';
  @Input() showUpBand = true;
  @Input() mode: FuseDrawerMode = 'over';
  @Input() name = '';
  @Input() opened = false;
  @Input() position: FuseDrawerPosition = 'right';
  @Input() transparentOverlay = true;
  @Input() disableOverlay = true;
  @Input() disableOverlayClose = true;
  @Input() showCloseButton = false;
  @Input() title = '';
  @Input() showHeader = true;
  @Input() showBackButton = false;

  // Outputs
  @Output() openedChanged = new EventEmitter<boolean>();
  @Output() closeClick = new EventEmitter<void>();
  @Output() backClick = new EventEmitter<void>();
  @Output() viewInitialized = new EventEmitter<void>();

  ngAfterViewInit() {
    this.viewInitialized.emit();
  }
}
